import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader
} from '@coreui/react';

import { apiClient } from 'services/Api';
import DataTableComponent from "components/DataTableComponent";
import AlertNotification from 'components/globals/AlertNotification';
import TextFieldCell from 'components/TextFieldCell';
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";

const InnovationActionList = () => {
    const navigate = useNavigate();
    const [innovationActions, setActions] = useState([]);
    const location = useLocation();
    const [previewInnovationAction, setPreviewInnovationAction] = useState(null);
    
    useEffect(() => {
        const fetchInnovationActions = async () => {
            try {
                const response = await apiClient.get(`/innovation-actions/`);
                setActions(response.data);
                setPreviewInnovationAction((current) => current
                    ? response.data.find((action) => action.id === current.id) || null
                    : null);
            } catch (error) {
                console.error('Error fetching action:', error);
            }
        };

        fetchInnovationActions();
    }, [location.pathname]);

    const columns = [
        { name: "Iniciativa", selector: (row) => row.name, sortable: true, className: 'text-center', grow: 2},
        { name: "Data arranque", selector: (row) => row.start_date, sortable: true },
        { name: "Caracter Recorrente ou Pontual", selector: (row) => row.occurrence_type, sortable: true },
        { name: "Periodicidade", selector: (row) => row.periodicity, sortable: true },
        { name: "Ativa", selector: (row) => row.active === true ? "Sim" : row.active === false ? "Não" : "", sortable: true },
        { name: "Fecho", selector: (row) => row.end_date, sortable: true },
        { name: "Obj. alcançados", selector: (row) => row.objectives_met === true ? "Sim" : row.objectives_met === false ? "Não" : "", sortable: true },
        { name: "Data de aval.", selector: (row) => row.evaluation_date, sortable: true },
        { name: "Eficaz", selector: (row) => row.efficiency === true ? "Sim" : row.efficiency === false ? "Não" : "", sortable: true },
        { name: "Obs.", selector: (row) => <TextFieldCell html={row.obs} onClick={() => setPreviewInnovationAction(row)} />, grow: 2 },
    ];

    return (
        <>
            <AlertNotification />
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Ações de Inovação</h3>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={innovationActions}
                        onRowClicked={setPreviewInnovationAction}
                    />
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewInnovationAction}
                onHide={() => setPreviewInnovationAction(null)}
                title="Ação de Inovação"
                subtitle={previewInnovationAction?.name}
                fields={previewInnovationAction ? [
                    { label: "Iniciativa", value: previewInnovationAction.name },
                    { label: "Data arranque", value: previewInnovationAction.start_date },
                    { label: "Carácter Recorrente ou Pontual", value: previewInnovationAction.occurrence_type },
                    { label: "Periodicidade", value: previewInnovationAction.periodicity },
                    { label: "Ativa", value: previewInnovationAction.active === true ? "Sim" : previewInnovationAction.active === false ? "Não" : "" },
                    { label: "Fecho", value: previewInnovationAction.end_date },
                    { label: "Objetivos alcançados", value: previewInnovationAction.objectives_met === true ? "Sim" : previewInnovationAction.objectives_met === false ? "Não" : "" },
                    { label: "Data de avaliação", value: previewInnovationAction.evaluation_date },
                    { label: "Eficaz", value: previewInnovationAction.efficiency === true ? "Sim" : previewInnovationAction.efficiency === false ? "Não" : "" },
                    { label: "Observações", value: <TextFieldCell html={previewInnovationAction.obs || "-"} />, plain: false },
                ] : []}
                headerActions={previewInnovationAction && (
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/acoes-inovacao/${previewInnovationAction.id}`)}>
                        Editar
                    </CButton>
                )}
            />
        </>
    );
};

export default InnovationActionList;
